import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Select from 'components/Select';

interface Props {
  title: string;
  btn: ReactNode;
  lng: string;
  setLanguage: (val: { value: string; label: string; }) => void;
  setCurrency: (val: { value: string; label: string; }) => void;
  currency: {
    code: string;
    currency: string;
    digits: number;
    number: string;
    updatedAt: string;
    use: boolean;
    world: boolean;
  };
  optionsLng: {
    value: string;
    label: string;
  }[];
  optionsCurr: {
    value: string;
    label: string;
  }[];
  metric: string;
  disable?: {
    metric?: boolean;
    currency?: boolean;
    language?: boolean;
  };
  setMetric: (value: string) => void;
}

/**
 * For green app forced French and EUR with
 * {@link useForceGreenLanguageAndCurrency.ts} hook
 */ 
const ChangeProfileBox = ({
  title,
  btn,
  optionsCurr,
  optionsLng,
  lng,
  currency,
  setLanguage,
  setCurrency,
  metric,
  setMetric,
  disable,
}: Props) => {
  const { t } = useTranslation();

  const options = [
    {
      value: 'Metric system',
      label: 'Metric system',
    },
    {
      value: 'Imperial system',
      label: 'Imperial system',
    },
  ];
  
  return (
    <div className="w-full flex flex-col p-8 border border-primitiveGrey rounded-2xl mb-8 md:m-0 md:w-full md:p-3">
      <div className="flex items-center mb-6">
        <div className="font-bold text-xl mr-4">{title}</div>
        <div>{btn}</div>
      </div>
      <div className="text-secondaryText mb-3">
        <Select
          value={[{
            value: lng,
            label: lng,
          }]}
          options={optionsLng}
          title={t('language')}
          disabled={disable?.language}
          onChange={(val) => setLanguage(val)}
        />
      </div>
      <div className="text-secondaryText mt-3 mb-3">
        <Select
          options={optionsCurr}
          disabled={disable?.currency}
          value={[{
            value: currency?.code,
            label: currency?.code,
          }]}
          title={t('currency')}
          onChange={(val) => setCurrency(val)}
        />
      </div>
      <div className="text-secondaryText mt-3">
        <Select
          options={options}
          disabled={disable?.metric}
          title={t('systemofUnits')}
          onChange={(val) => setMetric(val.value)}
          value={[
            {
              value: metric,
              label: metric,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default ChangeProfileBox;
